module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("INTRODUCTION")])])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Music theory is the study of music itself—it attempts to decipher why the patterns in music are what they are and how that in turn makes music work. Music is, after all, a highly intricate and structured art form that involves a great deal of math, science, and acoustics. And it’s true that understanding music takes time and effort. But learning more about the music you love doesn’t have to be a challenge! This guide will help you master the tools you need to read, play, and comprehend music.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book is different from other books on music theory that you may have bought. Many theory books cater to the experienced musician and are filled with complex terms and assumptions that can overwhelm the everyday reader. These books also tend to focus on classical music and often ignore other types of music. In comparison, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Music Theory 101")]), _vm._v(" presents the topic in a clear, easy-to-understand fashion that encompasses many musical genres and instruments.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whether you play music or just want to know more about it, this book will help you understand how music works and how all its elements fit together. Music theory takes the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("sounds")]), _vm._v(" of music and translates them into "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("words")]), _vm._v("; it takes a look at how music has evolved over the years and explores what we can learn from those changes.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("This book covers the essential aspects you need to know, such as:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• How to understand rhythm and time signatures")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• How chords and scales are constructed")])]), _c('p', {
    staticClass: "bull"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("• How to write and understand traditional harmony")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "bull"
  }, [_vm._v("• How to identify keys and how keys are organized")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• How to understand articulations and ornaments on written music")]), _vm._v(" "), _c('p', {
    staticClass: "bullb"
  }, [_vm._v("• How to use modes to expand harmony")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Music theory doesn’t have to be confusing or overly complicated. And while it can be true that learning music theory is not an easy task, this book will lead you through the process with confidence and clarity. So let’s explore (and demystify) the fascinating world of music theory.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Note:")]), _vm._v(" In addition to examples in standard music notation, you’ll also see guitar tablature included in many of the figures as well as guitar chord diagrams. If you play guitar, you’ll be able to play along with many of the examples included in this book and strum along with the harmonies to help you learn.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6924e83b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/intro.vue
// module id = 69
// module chunks = 0